var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("权限管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("权限组设置")]),
          _c("h4", [_vm._v("数据筛选")]),
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "权限组" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "请输入权限组" },
                        model: {
                          value: _vm.searchWord,
                          callback: function ($$v) {
                            _vm.searchWord = $$v
                          },
                          expression: "searchWord",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.parArray.indexOf("authorityAdd") == 1
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.showDialog("新增权限组", "addPermission")
                    },
                  },
                },
                [_vm._v("新增权限")]
              )
            : _vm._e(),
          _c("lb-table", {
            attrs: {
              column: _vm.column,
              data: _vm.permissionList,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: "30%",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _vm.dialog.type == "addPermission"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "addPermissionForm",
                          attrs: {
                            model: _vm.addPermissionForm,
                            rules: _vm.addPermissionRules,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "权限组名称", prop: "name" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.addPermissionForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addPermissionForm, "name", $$v)
                                  },
                                  expression: "addPermissionForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialog.type == "editName"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "addPermissionForm",
                          attrs: {
                            model: _vm.addPermissionForm,
                            rules: _vm.addPermissionRules,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "权限组名称", prop: "name" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.addPermissionForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addPermissionForm, "name", $$v)
                                  },
                                  expression: "addPermissionForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialog.type == "roleList"
                ? _c("div", { staticClass: "roleList" }, [
                    _c(
                      "div",
                      { staticClass: "title" },
                      [
                        _vm._v(" 已关联"),
                        _c("el-badge", {
                          attrs: {
                            value: _vm.permissionRoleList.length,
                            type: "primary",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.permissionRoleList, function (k) {
                        return _c("el-tag", { key: k.index }, [
                          _vm._v(_vm._s(k.name)),
                        ])
                      }),
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.dialog.type == "editPermission"
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.tabsClick },
                      model: {
                        value: _vm.tabsActiveName,
                        callback: function ($$v) {
                          _vm.tabsActiveName = $$v
                        },
                        expression: "tabsActiveName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "权限配置", name: "config" } },
                        [
                          _c("el-input", {
                            staticStyle: { margin: "0 0px 20px" },
                            attrs: { placeholder: "输入关键字进行搜索" },
                            model: {
                              value: _vm.permissionFilterText,
                              callback: function ($$v) {
                                _vm.permissionFilterText = $$v
                              },
                              expression: "permissionFilterText",
                            },
                          }),
                          _c("el-tree", {
                            ref: "tree",
                            attrs: {
                              data: _vm.permission.config.list,
                              props: _vm.permission.config.defaultProps,
                              "show-checkbox": true,
                              "node-key": "id",
                              "highlight-current": "",
                              "filter-node-method": _vm.filterNode,
                              "expand-on-click-node": false,
                              "check-strictly":
                                _vm.permission.config.checkStrictly,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "数据权限", name: "data" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.permission.data,
                                callback: function ($$v) {
                                  _vm.$set(_vm.permission, "data", $$v)
                                },
                                expression: "permission.data",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.data_permission,
                              function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.dictId,
                                    attrs: { label: item.dictId },
                                  },
                                  [_vm._v(_vm._s(item.dictName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "销售权限", name: "sale" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.permission.sale,
                                callback: function ($$v) {
                                  _vm.$set(_vm.permission, "sale", $$v)
                                },
                                expression: "permission.sale",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.sales_authority,
                              function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.dictId,
                                    attrs: { label: item.dictId },
                                  },
                                  [_vm._v(_vm._s(item.dictName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }